<app-loader *ngIf="loading"></app-loader>

<ng-container *ngIf="!loading">
    <div class="page-wrapper content">
        <app-basic-header
                [ttsIconState]="ttsIconState"
                [stopAudio]="pauseAudioSubject.asObservable()"
                [informationUnitTitle]="unitTitleHeader"
                [leaveButtonLabel]="'LEAVE'"
                [submittedConsentId]="this.submittedConsentId"
                (playFromStartAudioEvent)="play()"
                (readTextEvent)="readText()"
                (leaveIndication)="onLeaveIndication()">
        </app-basic-header>

        <div class="content__text basic-text">
            <app-basic-display-consent-text
                    [textToDisplay]="textToDisplay"
                    [textSize]="textSize"
                    [indicationId]="indicationId">
            </app-basic-display-consent-text>
        </div>
        <div class="content__footer">
            <app-basic-display-consent-footer
                    [displayFinish]="showFinishBtn"
                    [backButtonDisabled]="backButtonDisabled"
                    [unitMarkedWithQuestion]="unitMarkedWithQuestion"
                    (emitBackEvent)="onBack()"
                    (emitContinueEvent)="onContinue()"
                    (emitCompleteEvent)="onComplete()"
                    (emitQuestionEvent)="onAddDeleteQuestion()">
            </app-basic-display-consent-footer>
        </div>
    </div>
</ng-container>

